<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
  import API from "./lmj_Api/api";
  import { mapState } from 'vuex';
export default {
  name: 'App',
  computed: {
      ...mapState(['userToken'])
    },
  //xhx 202506041934 添加为了定时清空uid
  mounted() {
    this.handleUserActivity = this.handleUserActivity.bind(this);
    // 添加全局事件监听
    this.addGlobalEventListeners();

    // 初始启动无操作计时器（如果已登录）
    if (this.$store.state.uid) {
      this.$store.commit('resetInactivityTimer');
    }
  },

  beforeDestroy() {
    // 移除事件监听器
    this.removeGlobalEventListeners();

    // 清除计时器
    if (this.$store.state.inactivityTimer) {
      clearTimeout(this.$store.state.inactivityTimer);
    }
  },

  methods: {
    // 用户活动处理函数
    handleUserActivity() {
      console.log("这个路由是什么呢",this.$route.path)
      // this.$store.commit('recordUserActivity');
      if (this.$route.path === '/GoodsAdduser') {
        console.log('用户注册不用跳转首页')
        return;
      }

        console.log('用户活动处理函数')
        var url = API.checktoken+'?uid='+localStorage.uid+"&userToken="+localStorage.userToken;
        this.axios.post(url).then(res => {
          if (res.data.code == 401) {
            localStorage.removeItem('uid');
             if (this.$route.path !== '/') {
               this.$router.push('/');
             }
          }
        });

    },

     // 处理页面关闭/刷新
        handlePageUnload() {
          // 清除登录状态
          this.$store.commit('clearUserSession');
        },

    // // 添加全局事件监听器
    addGlobalEventListeners() {
        console.log('添加全局事件监听器');
        // const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
        const events = [ 'click'];
        events.forEach(event => {
              window.addEventListener(event, this.handleUserActivity);
        });
    },

    // // 移除全局事件监听器
    removeGlobalEventListeners() {
      console.log('移除全局事件监听器');
      const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
      events.forEach(event => {
        window.removeEventListener(event, this.handleUserActivity);
      });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue